import styled from 'styled-components';
export const Container = styled.div `
  * {
    transition: all 0.2s;
  }

  height: 24px;
  padding: 4px 12px;
  align-items: center;
  border-style: solid;
  display: inline-flex;
  transition: border-color 0.2s, background-color 0.2s;
  font-size: var(--font-size-xs);
  border-radius: var(--border-radius-lg);
  font-weight: var(--font-weight-semibold);

  &.has-icon-left {
    padding-left: 8px;
    svg:first-child {
      width: 12px;
      height: 12px;
      margin-right: 4px;
    }
  }

  &.default {
    background-color: var(--color-neutral-200);
    border-width: 0;
  }

  &.positive {
    color: var(--color-feedback-positive-600) !important;
    background-color: var(--color-feedback-positive-100);
    border-width: 0;
  }

  &.negative {
    color: var(--color-feedback-danger-600) !important;
    background-color: var(--color-feedback-danger-100);
    border-width: 0;
  }
`;
//# sourceMappingURL=style.js.map